import { Component, type ReactNode, type ErrorInfo } from 'react';

interface Props { children: ReactNode }
interface State { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
          <p className="text-[#4b5563] text-sm max-w-md">
            Something went wrong. Reload the page or return to the dashboard.
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.reload();
              }}
              className="px-4 py-2 rounded-lg bg-[#0070e0] text-white text-sm font-medium hover:bg-[#0060c0]"
            >
              Reload page
            </button>
            <a
              href="/dashboard"
              onClick={() => this.setState({ hasError: false })}
              className="px-4 py-2 rounded-lg border border-[#e5e5e5] text-sm font-medium text-[#1f2937] hover:bg-[#f9f9f9]"
            >
              Go to use case register
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
